import React, { useState } from "react";
import { FaChevronDown } from "react-icons/fa";

const AboutJourney = () => {
  const [activeItem, setActiveItem] = useState(1); 

  const handleToggle = (itemIndex) => {
    if (activeItem === itemIndex) {
      setActiveItem(null); 
    } else {
      setActiveItem(itemIndex); 
    }
  };

  return (
    <div className="w-full px-4 py-6 rounded-lg custom-padding xl-screen-padding pt-80 pb-80">
      <div className="text-left mb-12">
        <h1 className="text-4xl font-merriweather text-gray-800 mb-4">
          The <span className="text-[#8f762c]">Nutrition</span> Journey
        </h1>
        <p className="text-p text-[#788086]">
          Your genetic variants account for approximately 30% of your overall health, significantly outweighing the 9% impact of traditional healthcare. By delving
          into your unique genetic profile, we can uncover how your body interacts with various foods and nutrients. This insight enables us to craft a bespoke
          nutrition plan tailored specifically to you. Our approach is to integrate your lifestyle and personal preferences, empowering you to make informed
          choices that align with your unique biology and living environment.
        </p>
      </div>
      <div>
        <div>
          <div className="mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            <div className="col-span-1">
              <div className="relative overflow-hidden rounded-lg">
                <img
                  src={require("../../src/assets/images/image_101.png")}
                  alt="Nutrition Consultation"
                  className="w-full journeyimg"
                />
              </div>
            </div>

            <div className="col-span-1">
              <ul className="space-y-8">
                <li
                  className="border-b-4 journey border-transparent pb-2 cursor-pointer hover:border-black hover:underline-effect"
                  onClick={() => handleToggle(1)}
                >
                  <div className="flex items-center justify-between">
                    <h3 className="text-lg font-bold font-merriweather">
                      Pre-Nutritional Counselling & Health Assessment
                    </h3>
                    <FaChevronDown
                      className={`transition-transform duration-300 ${activeItem === 1 ? "rotate-180" : ""}`}
                    />
                  </div>
                  {activeItem === 1 && (
                    <p className="text-[#aeaea6] mt-4">
                      Your journey begins with an in-depth consultation, where
                      we take the time to understand your health history, current
                      medical conditions, and lifestyle. This foundational step
                      ensures that we craft a plan tailored to your unique needs.
                    </p>
                  )}
                </li>
                <li
                  className="border-b-4 journey border-transparent pb-2 cursor-pointer hover:border-black hover:underline-effect"
                  onClick={() => handleToggle(2)}
                >
                  <div className="flex items-center justify-between">
                    <h3 className="text-lg font-bold font-merriweather">
                      Advanced Testing to Uncover Your Body’s Blueprint
                    </h3>
                    <FaChevronDown
                      className={`transition-transform duration-300 ${activeItem === 2 ? "rotate-180" : ""}`}
                    />
                  </div>
                  {activeItem === 2 && (
                    <p className="text-[#aeaea6] mt-4">
                      We conduct advanced tests that give us insights into your
                      body's unique blueprint, helping us design a customized
                      nutrition plan based on your specific needs and health
                      goals.
                    </p>
                  )}
                </li>
                <li
                  className="border-b-4 journey border-transparent pb-2 cursor-pointer hover:border-black hover:underline-effect"
                  onClick={() => handleToggle(3)}
                >
                  <div className="flex items-center justify-between">
                    <h3 className="text-lg font-bold font-merriweather">
                      A Personalised 6-Month Roadmap
                    </h3>
                    <FaChevronDown
                      className={`transition-transform duration-300 ${activeItem === 3 ? "rotate-180" : ""}`}
                    />
                  </div>
                  {activeItem === 3 && (
                    <p className="text-[#aeaea6] mt-4">
                      Based on the results of your health assessments, we’ll
                      design a personalized roadmap to help you reach your health
                      and wellness goals in a structured, achievable 6-month plan.
                    </p>
                  )}
                </li>
                <li
                  className="border-b-4 journey border-transparent pb-2 cursor-pointer hover:border-black hover:underline-effect"
                  onClick={() => handleToggle(4)}
                >
                  <div className="flex items-center justify-between">
                    <h3 className="text-lg font-bold font-merriweather">
                      Ongoing Expert Support & Counselling
                    </h3>
                    <FaChevronDown
                      className={`transition-transform duration-300 ${activeItem === 4 ? "rotate-180" : ""}`}
                    />
                  </div>
                  {activeItem === 4 && (
                    <p className="text-[#aeaea6] mt-4">
                      We provide continuous expert support to ensure you stay on
                      track with your health plan, offering guidance and advice as
                      needed along the way.
                    </p>
                  )}
                </li>
                <li
                  className="border-b-4 journey border-transparent pb-2 cursor-pointer hover:border-black hover:underline-effect"
                  onClick={() => handleToggle(5)}
                >
                  <div className="flex items-center justify-between">
                    <h3 className="text-lg font-bold font-merriweather">
                      Tailored Programs to Suit Your Needs
                    </h3>
                    <FaChevronDown
                      className={`transition-transform duration-300 ${activeItem === 5 ? "rotate-180" : ""}`}
                    />
                  </div>
                  {activeItem === 5 && (
                    <p className="text-[#aeaea6] mt-4">
                      Our nutrition programs are fully customizable, ensuring
                      that every aspect is aligned with your health goals, whether
                      you're looking to lose weight, increase energy, or improve
                      overall wellness.
                    </p>
                  )}
                </li>
                <li
                  className="border-b-4 journey border-transparent pb-2 cursor-pointer hover:border-black hover:underline-effect"
                  onClick={() => handleToggle(6)}
                >
                  <div className="flex items-center justify-between">
                    <h3 className="text-lg font-bold font-merriweather">
                      Consistent Handholding and Flexibility
                    </h3>
                    <FaChevronDown
                      className={`transition-transform duration-300 ${activeItem === 6 ? "rotate-180" : ""}`}
                    />
                  </div>
                  {activeItem === 6 && (
                    <p className="text-[#aeaea6] mt-4">
                      We understand that everyone’s journey is unique, which is
                      why we offer flexible support, guiding you at every step
                      while providing you the freedom to adjust the plan as needed.
                    </p>
                  )}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutJourney;
